import { useQuery, QueryClient } from 'react-query';
import { getPrivateApi } from '../../../../services/api';
import { purge } from '@vy/utils';
import type { CustomUseQueryOptions } from '../../requests-types/custom-use-query-options';
import { useActivatedIntegration } from '../../../use-activated-integration';
import { INTEGRATION_PROVIDERS } from '@vy/types';
import type { XeroGetProductsResponse } from '@vy/api-definition';
import { queryKeys } from '../../../../services/query-key/query-keys';

async function xeroProductsQuery(searchParam?: string) {
  const api = getPrivateApi();
  const response = await api.xeroGetProducts({ search: searchParam });

  return response;
}

export function useXeroProducts(
  searchParam?: string,
  options?: CustomUseQueryOptions<XeroGetProductsResponse>,
) {
  const isXeroActivated = useActivatedIntegration(INTEGRATION_PROVIDERS.xero);

  const queryDeps = purge([searchParam]);

  return useQuery(
    queryKeys.xeroProducts(...queryDeps),
    () => xeroProductsQuery(searchParam),
    {
      ...options,
      enabled: isXeroActivated,
    },
  );
}

export function prefetchXeroProducts(queryClient: QueryClient, searchParam?: string) {
  const queryDeps = purge([searchParam]);

  return queryClient.prefetchQuery(
    queryKeys.xeroProducts(...queryDeps),
    () => xeroProductsQuery(searchParam),
  );
}
